/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSourceMergePreview200ResponseDataSourceToMerge } from './GetSourceMergePreview200ResponseDataSourceToMerge';
import {
    GetSourceMergePreview200ResponseDataSourceToMergeFromJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeFromJSONTyped,
    GetSourceMergePreview200ResponseDataSourceToMergeToJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeToJSONTyped,
} from './GetSourceMergePreview200ResponseDataSourceToMerge';

/**
 * 
 * @export
 * @interface GetSourceBulkMergePreview200ResponseData
 */
export interface GetSourceBulkMergePreview200ResponseData {
    /**
     * 
     */
    sources_to_merge: Array<GetSourceMergePreview200ResponseDataSourceToMerge>;
    /**
     * 
     */
    merged_source?: GetSourceMergePreview200ResponseDataSourceToMerge;
}

/**
 * Check if a given object implements the GetSourceBulkMergePreview200ResponseData interface.
 */
export function instanceOfGetSourceBulkMergePreview200ResponseData(value: object): value is GetSourceBulkMergePreview200ResponseData {
    if (!('sources_to_merge' in value) || value['sources_to_merge'] === undefined) return false;
    return true;
}

export function GetSourceBulkMergePreview200ResponseDataFromJSON(json: any): GetSourceBulkMergePreview200ResponseData {
    return GetSourceBulkMergePreview200ResponseDataFromJSONTyped(json, false);
}

export function GetSourceBulkMergePreview200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceBulkMergePreview200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'sources_to_merge': ((json['sources_to_merge'] as Array<any>).map(GetSourceMergePreview200ResponseDataSourceToMergeFromJSON)),
        'merged_source': json['merged_source'] == null ? undefined : GetSourceMergePreview200ResponseDataSourceToMergeFromJSON(json['merged_source']),
    };
}

export function GetSourceBulkMergePreview200ResponseDataToJSON(json: any): GetSourceBulkMergePreview200ResponseData {
    return GetSourceBulkMergePreview200ResponseDataToJSONTyped(json, false);
}

export function GetSourceBulkMergePreview200ResponseDataToJSONTyped(value?: GetSourceBulkMergePreview200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sources_to_merge': ((value['sources_to_merge'] as Array<any>).map(GetSourceMergePreview200ResponseDataSourceToMergeToJSON)),
        'merged_source': GetSourceMergePreview200ResponseDataSourceToMergeToJSON(value['merged_source']),
    };
}

